export const tafButton = () => {
  const button = document.querySelector("[data-wm-taf-button]");

  if (!button) {
    return;
  }

  let wasAlreadySent = false;

  const trackTafSharing = () => {
    if (!wasAlreadySent) {
      fetch(button.dataset.wmTafTrackUrl);
    }

    wasAlreadySent = true;

    window.location.href = button.dataset.wmTafButtonMailto;
  };

  button.addEventListener("click", trackTafSharing);
};
